import Patch from "@shared/models/patch-updater"
import defaultCourseDateActivity from "./default-course-date-activity"
import defaultCourseDateContext from "./default-course-date-context"
import defaultCourseDateModels from "./default-course-date-models"
import moment from "moment"

export const COURSE_DATE_ANNOTATION_HIDE = {
  name: "COURSE_DATE_ANNOTATION_HIDE",

  params: {
    annotation: "object",
    course: "object",
  },

  patches(payload) {
    let patch = Patch.create("course", payload.course.id, "attributes.calendar.dateAnnotations", {
      id: payload.annotation.id,
    })
      .set("embedded", `attributes.showAnnotation`, false)
      .inc("attributes.calendar.version", 1)

    return [patch.patch]
  },
  undoPatches(payload) {
    let patch = Patch.create("course", payload.course.id, "attributes.calendar.dateAnnotations", {
      id: payload.annotation.id,
    })
      .set("embedded", `attributes.showAnnotation`, true)
      .inc("attributes.calendar.version", 1)

    return [patch.patch]
  },

  narrative(payload, findFn, userId) {
    let models = defaultCourseDateModels(payload, findFn, userId)
    let courseTitle = payload.course.attributes.title
    let date = moment(payload.annotation.attributes.dateString).format("ddd, MMM. D, YYYY")

    return {
      title: "Chose To Hide A Class Note",
      titleForAnalytics: "Lesson - Hide Annotation",
      description: `Completely hide your ${courseTitle} class on ${date}`,
      context: defaultCourseDateContext(payload, models),
      activity: defaultCourseDateActivity(payload, models, "hide"),
    }
  },
}

export default COURSE_DATE_ANNOTATION_HIDE
